export default __webpack_public_path__ + "static/media/eye.ab9b0638.svg";